import React from 'react';
import { SectionWrapper } from './ui/SectionWrapper';
import { Button } from './ui/Button';
import { Shield, Lock, Zap } from 'lucide-react';
import { CountdownTimer } from './ui/CountdownTimer';
export function FinalCTA() {
  return <SectionWrapper className="text-center pb-12 md:pb-24 px-4 md:px-0" data-id="element-43">
      <div className="max-w-2xl mx-auto" data-id="element-44">
        <h2 className="text-[11px] md:text-sm font-black tracking-widest text-slate-500 uppercase mb-4 md:mb-8" data-id="element-45">
          🔚 ÚLTIMO MENSAJE
        </h2>

        <div className="text-[26px] md:text-4xl font-extrabold mb-8 md:mb-10 leading-tight text-white" data-id="element-46">
          Si vos no guiás…
          <br data-id="element-47" />
          <span className="text-blue-400" data-id="element-48">👉 alguien más lo va a hacer</span>
        </div>

        <div className="flex flex-col md:flex-row justify-center gap-2 md:gap-4 mb-10 md:mb-16 text-sm md:text-xl font-bold text-slate-300" data-id="element-49">
          <span className="bg-brand-darkCard px-4 py-3 md:px-6 md:py-3 rounded-xl border border-slate-700 w-full md:w-auto" data-id="element-50">
            Una red social
          </span>
          <span className="bg-brand-darkCard px-4 py-3 md:px-6 md:py-3 rounded-xl border border-slate-700 w-full md:w-auto" data-id="element-51">
            Un desconocido
          </span>
          <span className="bg-brand-darkCard px-4 py-3 md:px-6 md:py-3 rounded-xl border border-slate-700 w-full md:w-auto" data-id="element-52">
            Un algoritmo
          </span>
        </div>

        <div className="bg-white shadow-2xl rounded-2xl md:rounded-3xl p-6 md:p-12 w-full" data-id="element-53">
          <h3 className="text-lg md:text-2xl font-black text-brand-navy mb-2" data-id="element-54">
            ⏰ ACTUÁ HOY
          </h3>
          <p className="text-[15px] md:text-xl text-brand-blue font-bold mb-4 md:mb-6" data-id="element-55">
            📘 SISTEMA DIGITAL COMPLETO
          </p>
          <div className="text-4xl md:text-5xl font-black text-brand-navy mb-4 md:mb-6 tracking-tight" data-id="element-56">
            $19.990 ARS
          </div>

          <div className="mb-6 md:mb-8" data-id="element-57">
            <p className="text-red-500 font-bold flex items-center justify-center gap-1.5 mb-2 md:mb-2 text-[13px] md:text-base" data-id="element-58">
              ⚠️ Esta oferta termina en:
            </p>
            <CountdownTimer data-id="element-59" />
          </div>

          <Button fullWidth className="py-4 md:py-5 text-[15px] md:text-xl mb-6 md:mb-8" onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-60">
            QUIERO PROTEGER A MIS HIJOS AHORA
          </Button>

          <div className="flex flex-wrap items-center justify-center gap-3 md:gap-6 text-[11px] md:text-sm text-brand-textLight font-medium" data-id="element-61">
            <span className="flex items-center gap-1" data-id="element-62">
              <Lock className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-blue" data-id="element-63" />{' '}
              Pago seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-64">
              <Zap className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-blue" data-id="element-65" />{' '}
              Acceso inmediato
            </span>
            <span className="flex items-center gap-1" data-id="element-66">
              <Shield className="w-3.5 h-3.5 md:w-4 md:h-4 text-brand-blue" data-id="element-67" />{' '}
              Garantía 7 días
            </span>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}